// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1h--a","buttons":"RemoveExpirationActionButtons_buttons__3cArt"};